export default {
	ddmm: 'DD/MM',
	yyyy: 'RRRR',
};
